import { Helmet } from "react-helmet";

import PublicationBanner from "components/Publications/Banner/PublicationBanner"; 
import PublicationContent from "components/Publications/Content/PublicationContent";
import PublicationStructure from "components/Publications/Structure/PublicationStructure";

const Publications = () => {
  return (
    <article>
      <Helmet>
          <title> CNP Seguros Holding Brasil | Acompanhe nossas publicações</title>
          <meta name="description" content="Disponibilizamos aqui nossas principais documentos e estudos técnicas." />
          <meta name="keywords" content="CNP Seguros, CNP Holding Brasil, documentos, relatórios, pesquisas, publicações, colaboração, transparência" />
      </Helmet>
      <PublicationBanner />
      <PublicationContent />
      <PublicationStructure />
    </article>  
  );
};

export default Publications;
